import { useBreakpointValue } from "@gluestack-style/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const formSchema = z.object({
  card: z.string().optional(),
  cardExpirationDate: z.date().optional(),
  cpf: z.string().optional(),
  withdrawValue: z.string(),
  bonusValue: z.string()
});

export type FormDataType = z.infer<typeof formSchema>;

export const EmergencyWithdrawController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { back, replace, push } = useNavigation();

  const [installments, setInstallments] = useState<number>(1);
  const [isLoadingInstallments, setIsLoadingInstallments] = useState(false);

  const {
    control,
    formState: { isValid, isSubmitting },
    watch,
    handleSubmit
  } = useForm<FormDataType>({
    resolver: zodResolver(formSchema),
    defaultValues: { withdrawValue: "0", bonusValue: "0" }
  });

  const withdrawValue = watch("withdrawValue");

  const totalValue = Number(withdrawValue);

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };

  const handleIncrementInstallments = () => {
    setIsLoadingInstallments(true);
    setInstallments((prevState) => prevState + 1);
    setTimeout(() => {
      setIsLoadingInstallments(false);
    }, 2000);
  };

  const handleDecrementInstallments = () => {
    setIsLoadingInstallments(true);
    setInstallments((prevState) => prevState - 1);
    setTimeout(() => {
      setIsLoadingInstallments(false);
    }, 2000);
  };

  const handleOnSubmitForm = handleSubmit(() => {
    push(ROUTES.emergencyWithdrawConfirm);
  });

  return {
    back,
    isMobile,
    handleGoToSales,
    handleIncrementInstallments,
    handleDecrementInstallments,
    installments,
    control,
    isLoadingInstallments,
    isValid,
    isSubmitting,
    handleOnSubmitForm,
    totalValue
  };
};
